import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useStoreActions, useStoreState } from 'easy-peasy';

const UpgradeToProPlanModal = ({
	showCloseButton = true
}) => {
	const { goBack } = useHistory();
	const setShowProPlanModal = useStoreActions(actions => actions.setShowProPlanModal);
	const showProPlanModal = useStoreState(state => state.showProPlanModal);

	const {
		link,
		description,
		feature,
		showContainer,
		isDisableRouteBack,
	} = useMemo(() => {

		if (!showProPlanModal || typeof showProPlanModal === 'boolean' || typeof showProPlanModal !== 'object') {
			return {
				link: '',
				description: 'Pipelines are a great way to visually manage & track your enquiries stage by stage in one central place. Each member of your team can have their own unique pipeline.',
				feature: 'Feature',
				showContainer: false,
				isDisableRouteBack: false,
			};
		}
		return {
			link: showProPlanModal.link,
			description: showProPlanModal.description,
			feature: showProPlanModal.feature,
			showContainer: showProPlanModal.showContainer,
			isDisableRouteBack: showProPlanModal.isDisableRouteBack,
		};
	}, [showProPlanModal]);

	const onClose = () => {
		setShowProPlanModal(false);
		if (!isDisableRouteBack)
			goBack();
	};

	if (!showContainer)
		return (
			<div className="modal modal--type1 upgrade-pro-plan-modal">
				<div className="modal-container upgrade-pro-plan-modal-container upgrade-pro-plan-modal-container-only-modal">
					<div className="upgrade-plan-header">
						<div className="upgrade-icon-wrap">
							<span className="material-icons lock-icon">lock</span>
						</div>
						{showCloseButton && <span
							onClick={onClose}
							className="material-icons close-icon">
              close
						</span>}
					</div>
					<div className="upgrade-plan-body">
						<div className="pro-text-wrap d-flex-v-center">
							<div className="pro-text">Pro</div>
							<div>Feature</div>
						</div>
						<div className="upgrade-title">
              Upgrade to our Pro Plan to access {feature}
						</div>
						<div className="upgrade-desc">
							{description}
						</div>
					</div>
					<div className="speak-to-sales-wrap d-flex mb-30">
						<a href={'mailto:adam@enquirybot.com'} className="speak-to-sales-btn cursor-pointer">
              Speak to sales
						</a>
					</div>
					<div className="learn-more-wrap">
						<a target="_blank" href={link} rel="noopener noreferrer" className="learn-more-text">Learn more</a>
						<span className="material-icons-outlined open-icon"> open_in_new</span>
					</div>
				</div>
			</div>
		);
	return <></>;
};

export default UpgradeToProPlanModal;